module.exports = "/_next/static/images/AdaptImage@2x-01260089d9c3545e89d470132f225a8b.webp";